/**
 * Generated by orval 🍺
 * Do not edit manually.
 * parktool API
 * Share a few Q-Park parking spots: users register plates and book days, the backend puts the right plate on each spot.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  NewPlate,
  PlateDto
} from '../models';

import { customFetch } from '../../fetcher.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListPlatesUrl = () => {




  return `/api/plates`
}

export const listPlates = async ( options?: Parameters<typeof customFetch>[1]): Promise<PlateDto[]> => {

  return customFetch<PlateDto[]>(getListPlatesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPlatesQueryKey = () => {
    return [
    `/api/plates`
    ] as const;
    }


export const getListPlatesQueryOptions = <TData = Awaited<ReturnType<typeof listPlates>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPlatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlates>>> = ({ signal }) => listPlates({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPlates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPlatesQueryResult = NonNullable<Awaited<ReturnType<typeof listPlates>>>
export type ListPlatesQueryError = unknown


export function useListPlates<TData = Awaited<ReturnType<typeof listPlates>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlates>>,
          TError,
          Awaited<ReturnType<typeof listPlates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlates<TData = Awaited<ReturnType<typeof listPlates>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlates>>,
          TError,
          Awaited<ReturnType<typeof listPlates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlates<TData = Awaited<ReturnType<typeof listPlates>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListPlates<TData = Awaited<ReturnType<typeof listPlates>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPlatesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAddPlateUrl = () => {




  return `/api/plates`
}

export const addPlate = async (newPlate: NewPlate, options?: Parameters<typeof customFetch>[1]): Promise<PlateDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<PlateDto>(getAddPlateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(newPlate)
  }
);}





export const getAddPlateMutationKey = () => ['addPlate'] as const;

export const getAddPlateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addPlate>>, TError,AddPlateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addPlate>>, TError,AddPlateMutationVariables, TContext> => {

const mutationKey = getAddPlateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addPlate>>, AddPlateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  addPlate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddPlateMutationResult = NonNullable<Awaited<ReturnType<typeof addPlate>>>
    export type AddPlateMutationBody = NewPlate
    export type AddPlateMutationError = unknown
    export type AddPlateMutationVariables = {data: NewPlate}

    export const useAddPlate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addPlate>>, TError,AddPlateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addPlate>>,
        TError,
        AddPlateMutationVariables,
        TContext
      > => {
      return useMutation(getAddPlateMutationOptions(options), queryClient);
    }
    export const getDeletePlateUrl = (id: string,) => {




  return `/api/plates/${id}`
}

/**
 * @summary Deletes the plate here (cancelling its upcoming bookings) and, if parktool added it, from the Q-Park vehicle list.
 */
export const deletePlate = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeletePlateUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeletePlateMutationKey = () => ['deletePlate'] as const;

export const getDeletePlateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePlate>>, TError,DeletePlateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePlate>>, TError,DeletePlateMutationVariables, TContext> => {

const mutationKey = getDeletePlateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePlate>>, DeletePlateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deletePlate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePlateMutationResult = NonNullable<Awaited<ReturnType<typeof deletePlate>>>

    export type DeletePlateMutationError = unknown
    export type DeletePlateMutationVariables = {id: string}

    /**
 * @summary Deletes the plate here (cancelling its upcoming bookings) and, if parktool added it, from the Q-Park vehicle list.
 */
export const useDeletePlate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePlate>>, TError,DeletePlateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePlate>>,
        TError,
        DeletePlateMutationVariables,
        TContext
      > => {
      return useMutation(getDeletePlateMutationOptions(options), queryClient);
    }
